import { ListingFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

export const getJsonLdApartmentComplex = (listing, seo) => {
  const firstPhoto = listing.photos.photoList[0];
  const image = firstPhoto
    ? ListingFormatter.buildPhotoUrl(firstPhoto.id, firstPhoto.verified)
    : '';
  return {
    '@context': 'https://schema.org',
    '@type': 'ApartmentComplex',
    name: 'Spotahome',
    image,
    address: {
      '@type': 'PostalAddress',
      addressCountry: listing.countryCode,
      addressLocality: listing.cityId,
      postalCode: listing.postalCode
    },
    url: seo.canonical,
    '@mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': seo.canonical
    }
  };
};

export default {
  getJsonLdApartmentComplex
};
